import { render, staticRenderFns } from "./account-settings-password.vue?vue&type=template&id=0018d75f&scoped=true&"
import script from "./account-settings-password.vue?vue&type=script&lang=ts&"
export * from "./account-settings-password.vue?vue&type=script&lang=ts&"
import style0 from "./account-settings-password.vue?vue&type=style&index=0&id=0018d75f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0018d75f",
  null
  
)

export default component.exports